import { Placement, EnrichmentConfig, EnrichmentRequest, TitleIDList } from "util/types/wps/enrichItemMetadata";

type orStringOrUndefined<T> = T | string | undefined

// EnrichItemMetadata V2 -- per-item config
export const stringifyEnrichmentsOnClient = (enrichment?: EnrichmentRequest[] | undefined): orStringOrUndefined<EnrichmentRequest[]> => (
    global.__SERVER__ === true ? enrichment : enrichment && JSON.stringify(enrichment)
)

// Return one request as JSON
export const enrichmentRequest = (titleID: string, playback?: boolean, preroll?: boolean, trailer?: boolean, watchlist?: boolean): EnrichmentRequest => ({
    titleID: titleID,
    playback: playback,
    preroll: preroll,
    trailer: trailer,
    watchlist: watchlist
})

export const createEnrichmentRequestsArgs = (titleID: string[], playback?: boolean, preroll?: boolean, trailer?: boolean, watchlist?: boolean) => {
    const requests = titleID.map(t => enrichmentRequest(t, playback, preroll, trailer, watchlist))
    return stringifyEnrichmentsOnClient(requests)
}

// EnrichItemMetadata V2.5 -- global config

const enrichmentConfig = (placement?: Placement, playback?: boolean, preroll?: boolean, trailer?: boolean, watchlist?: boolean): EnrichmentConfig => ({
    placement: placement,
    playback: playback,
    preroll: preroll,
    trailer: trailer,
    watchlist: watchlist
})


const stringifyConfigOnClient = (config?: EnrichmentConfig | undefined): orStringOrUndefined<EnrichmentConfig> => (
    global.__SERVER__ === true ? config : config && JSON.stringify(config)
)

const stringifyTitleIDsOnClient = (list?: TitleIDList | undefined): orStringOrUndefined<TitleIDList> => (
    global.__SERVER__ === true ? list : list && JSON.stringify(list)
)

export const createConfigArg = (prerolls: Placement) => {
    const config = enrichmentConfig(prerolls)
    return stringifyConfigOnClient(config)
}

export const v2Request = (titleIDs: string[], placement: Placement, playback?: boolean, preroll?: boolean, trailer?: boolean, watchlist?: boolean) => {
    const titleIDArg = stringifyTitleIDsOnClient(titleIDs)
    const metadataToEnrich = enrichmentConfig(placement, playback, preroll, trailer, watchlist)
    const metadataArg = stringifyConfigOnClient(metadataToEnrich)
    return {
        metadataToEnrich: metadataArg,
        titleIDsToEnrich: titleIDArg
    }
}